module.exports = __webpack_public_path__ + "img/log2.f1757f43.svg";